// Mock Users
export const users = [
  {
    id: '1',
    email: 'student@shem.co.za',
    password: 'Shem@123',
    firstName: 'John',
    lastName: 'Smith',
    role: 'student',
    cohort: 'Cohort 2026',
    feesPaid: true,
    timezone: 'Africa/Johannesburg',
    avatar: 'JS',
    progress: {
      modulesCompleted: 8,
      totalModules: 12,
      assignmentsCompleted: 15,
      totalAssignments: 20,
      averageGrade: 78,
      studyHours: 45
    }
  },
  {
    id: '2',
    email: 'teacher@shem.co.za',
    password: 'Shem@123',
    firstName: 'Sarah',
    lastName: 'Johnson',
    role: 'teacher',
    subject: 'Kingdom Economics',
    avatar: 'SJ',
    officeHours: 'Mon-Fri 9AM-3PM'
  },
  {
    id: '3',
    email: 'admin@shem.co.za',
    password: 'Shem@123',
    firstName: 'Deon',
    lastName: 'Barnard',
    role: 'admin',
    avatar: 'MB'
  },
  {
    id: '4',
    email: 'tmgletshedi@gmail.com',
    password: 'admin12345678$',
    firstName: 'Thato',
    lastName: 'Letshedi',
    role: 'admin',
    roles: ['admin', 'teacher'],
    avatar: 'TL'
  },
  {
    id: '5',
    email: 'deon@revivalmedia-agency.com',
    password: 'admin12345678$',
    firstName: 'Deon',
    lastName: 'Barnard',
    role: 'admin',
    roles: ['admin', 'teacher'],
    avatar: 'DB'
  },
  {
    id: '6',
    email: 'pastorprincisca@gmail.com',
    password: 'teacher12345678$',
    firstName: 'Princisca',
    lastName: 'Tanyanyiwa',
    role: 'teacher',
    avatar: 'PT'
  },
  {
    id: '7',
    email: 'pastorxtreme@gmail.com',
    password: 'teacher12345678$',
    firstName: 'Xtreme',
    lastName: 'Tanyanyiwa',
    role: 'teacher',
    avatar: 'XT'
  },
  {
    id: '8',
    email: 'bheki.ndaba@gmail.com',
    password: 'teacher12345678$',
    firstName: 'Bheki',
    lastName: 'Ndaba',
    role: 'teacher',
    subject: 'Publishing & Kingdom Media',
    avatar: 'BN'
  },
  {
    id: '9',
    email: 'mrsatkhumalo@gmail.com',
    password: 'teacher12345678$',
    firstName: 'Sathkhalo',
    lastName: 'Khumalo',
    role: 'teacher',
    subject: 'Advocacy & Kingdom Leadership',
    avatar: 'SK'
  }
];

// Mock Assignments
export const assignments = [
  {
    id: '1',
    title: 'Foundations of Biblical Economics Essay',
    description: 'Write a 2000-word essay on the biblical foundations of economic stewardship.',
    module: 'Module 1: Foundations of Biblical Economics',
    dueDate: '2026-01-15',
    dueTime: '23:59',
    details: {
      overview: 'Explore the core biblical principles of stewardship and how they shape financial decision-making.',
      learningOutcomes: [
        'Explain key biblical texts on stewardship',
        'Apply principles to modern economic challenges',
        'Develop a personal stewardship framework'
      ],
      instructions: [
        'Use at least 4 scripture references',
        'Include a real-world case study',
        'Follow the provided essay structure'
      ],
      deliverables: [
        '2000-word essay (PDF or DOCX)',
        'Reference list in APA format'
      ],
      rubricHighlights: [
        'Understanding of principles (30%)',
        'Critical analysis (30%)',
        'Practical application (25%)',
        'Writing quality (15%)'
      ],
      resources: [
        'Module 1 Workbook',
        'Reading Materials: Biblical Foundations'
      ],
      estimatedTime: '4-6 hours'
    },
    rubric: [
      { criteria: 'Understanding of biblical principles', weight: 30 },
      { criteria: 'Critical analysis', weight: 30 },
      { criteria: 'Practical application', weight: 25 },
      { criteria: 'Writing quality', weight: 15 }
    ],
    status: 'open',
    attachments: ['rubric.pdf', 'reading_materials.pdf']
  },
  {
    id: '2',
    title: 'Debt Elimination Strategy Report',
    description: 'Create a comprehensive debt elimination strategy for a hypothetical family.',
    module: 'Module 2: Breaking the Debt Cycle',
    dueDate: '2026-01-20',
    dueTime: '23:59',
    details: {
      overview: 'Build a step-by-step debt elimination plan grounded in biblical and practical financial principles.',
      learningOutcomes: [
        'Assess debt categories and risks',
        'Prioritize repayment strategies',
        'Create a sustainable budget plan'
      ],
      instructions: [
        'Use the provided case study data',
        'Include a 6-month repayment schedule',
        'Explain your prioritization method'
      ],
      deliverables: [
        'Strategy report (1200-1500 words)',
        'Repayment schedule table'
      ],
      rubricHighlights: [
        'Strategic thinking (35%)',
        'Practical feasibility (35%)',
        'Research quality (20%)',
        'Presentation (10%)'
      ],
      resources: [
        'Case Study Packet',
        'Debt Cycle Worksheet'
      ],
      estimatedTime: '3-4 hours'
    },
    rubric: [
      { criteria: 'Strategic thinking', weight: 35 },
      { criteria: 'Practical feasibility', weight: 35 },
      { criteria: 'Research quality', weight: 20 },
      { criteria: 'Presentation', weight: 10 }
    ],
    status: 'open',
    attachments: ['case_study.pdf']
  },
  {
    id: '3',
    title: 'Investment Portfolio Analysis',
    description: 'Analyze and recommend an investment portfolio aligned with biblical principles.',
    module: 'Module 3: Kingdom Investing',
    dueDate: '2026-01-10',
    dueTime: '23:59',
    details: {
      overview: 'Evaluate investment options and propose a portfolio that aligns with ethical stewardship.',
      learningOutcomes: [
        'Analyze risk vs. return',
        'Apply ethical screening criteria',
        'Justify portfolio allocation'
      ],
      instructions: [
        'Review the provided market data',
        'Select 3-5 investment vehicles',
        'Include a 12-month projection'
      ],
      deliverables: [
        'Portfolio analysis report (1000-1200 words)',
        'Allocation chart'
      ],
      rubricHighlights: [
        'Risk assessment (25%)',
        'Biblical alignment (30%)',
        'Return projections (30%)',
        'Ethics consideration (15%)'
      ],
      resources: [
        'Market Data Spreadsheet',
        'Ethical Screening Guide'
      ],
      estimatedTime: '3-5 hours'
    },
    rubric: [
      { criteria: 'Risk assessment', weight: 25 },
      { criteria: 'Biblical alignment', weight: 30 },
      { criteria: 'Return projections', weight: 30 },
      { criteria: 'Ethics consideration', weight: 15 }
    ],
    status: 'submitted',
    attachments: ['market_data.xlsx']
  },
  {
    id: '4',
    title: 'Generational Wealth Plan',
    description: 'Develop a plan for building generational wealth within your family structure.',
    module: 'Module 5: Generational Wealth Transfer',
    dueDate: '2026-01-25',
    dueTime: '23:59',
    details: {
      overview: 'Design a sustainable plan that outlines how wealth can be built and passed down responsibly.',
      learningOutcomes: [
        'Create a legacy roadmap',
        'Identify legal and family structures',
        'Align wealth planning with values'
      ],
      instructions: [
        'Include a 5-year roadmap',
        'Outline family roles and responsibilities',
        'Address legal considerations'
      ],
      deliverables: [
        'Wealth plan report (1500-2000 words)',
        'Roadmap timeline'
      ],
      rubricHighlights: [
        'Long-term vision (30%)',
        'Implementation strategy (30%)',
        'Family involvement (25%)',
        'Legal considerations (15%)'
      ],
      resources: [
        'Legacy Planning Template',
        'Family Governance Notes'
      ],
      estimatedTime: '4-6 hours'
    },
    rubric: [
      { criteria: 'Long-term vision', weight: 30 },
      { criteria: 'Implementation strategy', weight: 30 },
      { criteria: 'Family involvement', weight: 25 },
      { criteria: 'Legal considerations', weight: 15 }
    ],
    status: 'open',
    attachments: []
  },
  {
    id: '5',
    title: 'Business Plan for Kingdom Enterprise',
    description: 'Create a detailed business plan for a kingdom-centered venture.',
    module: 'Module 6: Kingdom Entrepreneurship',
    dueDate: '2026-01-30',
    dueTime: '23:59',
    details: {
      overview: 'Develop a business plan that aligns mission, market, and biblical stewardship.',
      learningOutcomes: [
        'Define mission-driven value proposition',
        'Create financial projections',
        'Outline go-to-market strategy'
      ],
      instructions: [
        'Use the provided business plan template',
        'Include a 12-month budget',
        'Highlight kingdom impact goals'
      ],
      deliverables: [
        'Business plan document',
        'One-page executive summary'
      ],
      rubricHighlights: [
        'Business model (25%)',
        'Kingdom alignment (30%)',
        'Financial projections (25%)',
        'Market analysis (20%)'
      ],
      resources: [
        'Business Plan Template',
        'Market Research Checklist'
      ],
      estimatedTime: '5-7 hours'
    },
    rubric: [
      { criteria: 'Business model', weight: 25 },
      { criteria: 'Kingdom alignment', weight: 30 },
      { criteria: 'Financial projections', weight: 25 },
      { criteria: 'Market analysis', weight: 20 }
    ],
    status: 'open',
    attachments: ['template.docx']
  }
];

// Mock Submissions
export const submissions = [
  {
    id: '1',
    assignmentId: '3',
    studentId: '1',
    submittedAt: '2026-01-08T14:30:00',
    content: 'My investment analysis and recommendations based on biblical principles...',
    files: ['investment_analysis.pdf'],
    status: 'submitted',
    marks: null
  }
];

// Mock Marks
export const marks = [
  {
    id: '1',
    studentId: '1',
    assignmentId: '1',
    thesis: 82,
    assignment: 78,
    tithes: 90,
    attendance: 95,
    tests: 75,
    finalGrade: 79.8,
    feedback: 'Excellent understanding of biblical principles. Great analysis!'
  },
  {
    id: '2',
    studentId: '1',
    assignmentId: '2',
    thesis: 75,
    assignment: 80,
    tithes: 90,
    attendance: 95,
    tests: 72,
    finalGrade: 77.4,
    feedback: 'Good practical approach. Consider more research on debt types.'
  },
  {
    id: '3',
    studentId: '1',
    testId: '1',
    testName: 'Midterm Assessment - Modules 1-3',
    score: 85,
    maxScore: 100,
    percentage: 85,
    feedback: 'Strong performance!'
  }
];

// Mock Resources
export const resources = [
  {
    id: '1',
    title: 'Session 1: The Consolation of Israel',
    module: 'Module 1: Masters of the Economy',
    type: 'video',
    duration: '2:15:00',
    date: '2026-01-03',
    isPaid: false,
    hasWorkbook: true,
    downloadUrl: '#'
  },
  {
    id: '2',
    title: 'Session 2: The Torah',
    module: 'Module 1: Masters of the Economy',
    type: 'video',
    duration: '2:00:00',
    date: '2026-01-10',
    isPaid: false,
    hasWorkbook: true,
    downloadUrl: '#'
  },
  {
    id: '3',
    title: 'Session 3: Masters of the Economy Part 1',
    module: 'Module 1: Masters of the Economy',
    type: 'video',
    duration: '2:10:00',
    date: '2026-01-17',
    isPaid: false,
    hasWorkbook: true,
    downloadUrl: '#'
  },
  {
    id: '4',
    title: 'The Judaeo Abrahamic Wealth Factor',
    module: 'Module 2: God\'s Wealth Masterplan',
    type: 'video',
    duration: '2:30:00',
    date: '2026-01-24',
    isPaid: true,
    hasWorkbook: true,
    downloadUrl: '#'
  },
  {
    id: '5',
    title: 'Kingdom Economic Mastery Book',
    module: 'Required Reading',
    type: 'epub',
    size: '2.4 MB',
    isPaid: false,
    hasWorkbook: false,
    downloadUrl: '#'
  },
  {
    id: '6',
    title: 'Kingdom Economic Mastery Audiobook',
    module: 'Required Reading',
    type: 'audiobook',
    duration: '8h 30m',
    isPaid: false,
    hasWorkbook: false,
    downloadUrl: '#'
  },
  {
    id: '7',
    title: 'Millionaires Connect (2023–2025) Overview',
    module: 'Program Insights',
    type: 'pdf',
    size: '1.2 MB',
    date: '2026-01-08',
    isPaid: false,
    hasWorkbook: false,
    downloadUrl: '/millionaires-connect'
  }
];

// Mock Announcements
export const announcements = [
  {
    id: '1',
    title: 'Live Session This Saturday',
    content: 'Join us this Saturday for an interactive session on Kingdom Investing. Dr. Tich will be covering Module 3 content with live Q&A.',
    category: 'Live Session Updates',
    date: '2026-01-06',
    author: 'Dr. Tich Tanyanyiwa',
    pinned: true,
    reactions: { thumbsUp: 12, pray: 8, check: 15 }
  },
  {
    id: '2',
    title: 'Assignment Deadline Reminder',
    content: 'This is a friendly reminder that the Investment Portfolio Analysis assignment is due on January 10th. Make sure to submit your work on time.',
    category: 'Program Updates',
    date: '2026-01-05',
    author: 'Sarah Johnson',
    pinned: false,
    reactions: { thumbsUp: 5, pray: 2, check: 8 }
  },
  {
    id: '3',
    title: 'New Study Materials Available',
    content: 'Module 4 and 5 study materials are now available in the Private Classroom. Digital workbooks can be downloaded from the Resources section.',
    category: 'Resources',
    date: '2026-01-04',
    author: 'Admin Team',
    pinned: false,
    reactions: { thumbsUp: 20, pray: 3, check: 25 }
  },
  {
    id: '4',
    title: 'Payment Plan Update',
    content: 'For students on monthly payment plans, please ensure your payment is processed by the 5th of each month to maintain access to all materials.',
    category: 'Payments',
    date: '2026-01-03',
    author: 'Finance Department',
    pinned: false,
    reactions: { thumbsUp: 3, pray: 1, check: 10 }
  },
  {
    id: '5',
    title: 'Millionaires Connect Program Overview (2023–2025)',
    content: 'A new overview is available covering the 90-day Kingdom economic coaching model, leadership team, curriculum pillars, assignments, and transformation outcomes. Read the full briefing in the public site under Millionaires Connect.',
    category: 'Program Updates',
    date: '2026-01-08',
    author: 'Admin Team',
    pinned: true,
    reactions: { thumbsUp: 18, pray: 6, check: 22 }
  }
];

// Mock Calendar Events
export const calendarEvents = [
  {
    id: '1',
    title: 'New Year Vision Session',
    date: '2026-01-01',
    time: '18:00',
    type: 'lecture',
    recurring: false,
    description: 'Kickoff and vision for the year ahead'
  },
  {
    id: '2',
    title: 'Reading Plan: Module 1',
    date: '2026-01-02',
    time: '20:00',
    type: 'assignment',
    recurring: false,
    description: 'Start the Module 1 reading plan'
  },
  {
    id: '3',
    title: 'Workbook Check-in',
    date: '2026-01-03',
    time: '17:00',
    type: 'assignment',
    recurring: false,
    description: 'Upload your workbook notes for feedback'
  },
  {
    id: '4',
    title: 'Live Lecture - Module 4',
    date: '2026-01-04',
    time: '10:00',
    type: 'lecture',
    recurring: true,
    description: 'Supernatural Encounters - Live in-person + broadcast'
  },
  {
    id: '5',
    title: 'Assignment Due: Module 1 Reflection',
    date: '2026-01-05',
    time: '23:59',
    type: 'assignment',
    recurring: false,
    description: 'Submit your reflection via the portal'
  },
  {
    id: '6',
    title: 'Live Lecture - Module 5',
    date: '2026-01-06',
    time: '18:00',
    type: 'lecture',
    recurring: true,
    description: 'The Heart of a Giver - Live broadcast'
  },
  {
    id: '7',
    title: 'Practice Quiz Window Opens',
    date: '2026-01-07',
    time: '08:00',
    type: 'test',
    recurring: false,
    description: 'Practice quiz for Modules 1-3'
  },
  {
    id: '8',
    title: 'Live Lecture - Module 5 Q&A',
    date: '2026-01-08',
    time: '19:00',
    type: 'lecture',
    recurring: false,
    description: 'Questions and answers session'
  },
  {
    id: '9',
    title: 'Assignment Due: Debt Strategy Draft',
    date: '2026-01-09',
    time: '23:59',
    type: 'assignment',
    recurring: false,
    description: 'Submit your draft for review'
  },
  {
    id: '10',
    title: 'Assignment Due: Investment Portfolio',
    date: '2026-01-10',
    time: '23:59',
    type: 'assignment',
    recurring: false,
    description: 'Submit your analysis via the portal'
  },
  {
    id: '11',
    title: 'Live Lecture - Module 6',
    date: '2026-01-11',
    time: '10:00',
    type: 'lecture',
    recurring: true,
    description: 'Kingdom Entrepreneurship - Live in-person + broadcast'
  },
  {
    id: '12',
    title: 'Financial Stewardship Workshop',
    date: '2026-01-12',
    time: '18:30',
    type: 'lecture',
    recurring: false,
    description: 'Hands-on budgeting and stewardship exercises'
  },
  {
    id: '13',
    title: 'Reading Review Quiz',
    date: '2026-01-13',
    time: '19:00',
    type: 'test',
    recurring: false,
    description: 'Short quiz on assigned readings'
  },
  {
    id: '14',
    title: 'Live Lecture - Module 6 Part 2',
    date: '2026-01-14',
    time: '18:00',
    type: 'lecture',
    recurring: false,
    description: 'Continuation of Kingdom Entrepreneurship'
  },
  {
    id: '15',
    title: 'Assignment Due: Foundations Essay',
    date: '2026-01-15',
    time: '23:59',
    type: 'assignment',
    recurring: false,
    description: 'Submit your essay via the portal'
  },
  {
    id: '16',
    title: 'Live Lecture - Module 7',
    date: '2026-01-16',
    time: '18:00',
    type: 'lecture',
    recurring: true,
    description: 'The Heart of a Giver - Live broadcast'
  },
  {
    id: '17',
    title: 'Case Study Submission',
    date: '2026-01-17',
    time: '21:00',
    type: 'assignment',
    recurring: false,
    description: 'Upload your case study response'
  },
  {
    id: '18',
    title: 'Midterm Assessment',
    date: '2026-01-18',
    time: '10:00',
    type: 'test',
    recurring: false,
    description: 'Modules 1-6 Assessment'
  },
  {
    id: '19',
    title: 'Live Lecture - Module 7 Q&A',
    date: '2026-01-19',
    time: '19:00',
    type: 'lecture',
    recurring: false,
    description: 'Q&A and testimony sharing'
  },
  {
    id: '20',
    title: 'Assignment Due: Generational Wealth Plan',
    date: '2026-01-20',
    time: '23:59',
    type: 'assignment',
    recurring: false,
    description: 'Submit your plan for review'
  }
];

// Mock Study Sessions
export const studySessions = [
  {
    id: '1',
    studentId: '1',
    date: '2026-01-06',
    startTime: '09:00',
    endTime: '10:30',
    duration: 90,
    module: 'Module 3: Kingdom Investing',
    notes: 'Reviewed investment principles and biblical foundations',
    resource: 'Kingdom Economic Mastery Book'
  },
  {
    id: '2',
    studentId: '1',
    date: '2026-01-05',
    startTime: '14:00',
    endTime: '16:00',
    duration: 120,
    module: 'Module 2: Breaking the Debt Cycle',
    notes: 'Completed debt elimination worksheet',
    resource: 'Digital Workbook - Module 2'
  },
  {
    id: '3',
    studentId: '1',
    date: '2026-01-04',
    startTime: '19:00',
    endTime: '20:30',
    duration: 90,
    module: 'Module 1: Masters of the Economy',
    notes: 'Watched session recordings and took notes',
    resource: 'Session 1-3 Recordings'
  }
];

// Mock Messages
export const messages = [
  {
    id: '1',
    senderId: '2',
    recipientId: '1',
    subject: 'Question about Assignment 3',
    content: 'Hi {{studentName}}, I noticed you submitted your investment portfolio analysis. Great work! I had a question about your recommendation for ethical investments - could you elaborate on why you chose those specific companies?',
    timestamp: '2026-01-07T10:30:00',
    read: false,
    thread: [
      {
        id: '1a',
        senderId: '1',
        recipientId: '2',
        content: 'Thank you for the feedback! I chose those companies because they have strong ethical guidelines and align with biblical principles of stewardship.',
        timestamp: '2026-01-07T11:15:00',
        read: true
      },
      {
        id: '1b',
        senderId: '2',
        recipientId: '1',
        content: 'That makes sense. Could you provide more details on how you assessed their ethical standing, {{studentName}}?',
        timestamp: '2026-01-07T14:00:00',
        read: false
      }
    ]
  },
  {
    id: '2',
    senderId: '2',
    recipientId: '3',
    subject: 'February campaign approvals',
    content: 'Hi Admin, the February intake assets are ready for review. Can you approve them for release?',
    timestamp: '2026-01-08T09:00:00',
    read: false,
    thread: [
      {
        id: '2a',
        senderId: '3',
        recipientId: '2',
        content: 'Looks good. Please add the QR code to the flyer and confirm the registration link.',
        timestamp: '2026-01-08T09:30:00',
        read: true
      },
      {
        id: '2b',
        senderId: '2',
        recipientId: '3',
        content: 'Done. QR added and the link points to /register.',
        timestamp: '2026-01-08T10:05:00',
        read: false
      }
    ]
  }
];

// Mock Games Data
export const gamesData = {
  quizRush: {
    questions: [
      {
        id: 1,
        question: 'Which principle best defines Kingdom stewardship?',
        options: ['Keeping everything private', 'Ownership without responsibility', 'Managing resources as a trustee for God', 'Avoiding planning'],
        correct: 2
      },
      {
        id: 2,
        question: 'What is a core outcome of the 12‑month program?',
        options: ['Short-term trading', 'Kingdom economic mastery', 'Government subsidies', 'Passive luck'],
        correct: 1
      },
      {
        id: 3,
        question: 'Which activity best supports long-term financial stability?',
        options: ['No budget', 'Emergency fund + giving plan', 'Only credit lines', 'Random spending'],
        correct: 1
      },
      {
        id: 4,
        question: 'A healthy economic system inside a family should prioritize:',
        options: ['Speed only', 'Clarity, structure, and stewardship', 'Impulse decisions', 'Silence about money'],
        correct: 1
      },
      {
        id: 5,
        question: 'Which is a biblical principle tied to prosperity in the program?',
        options: ['Sowing and reaping', 'Avoiding all planning', 'Debt dependence', 'Isolation'],
        correct: 0
      }
    ]
  },
  decisionLab: {
    scenarios: [
      {
        id: 1,
        prompt: 'A client offers a fast deal that violates your values. What do you do?',
        options: ['Accept it for quick cash', 'Decline and seek aligned opportunities'],
        correct: 1,
        feedback: 'Kingdom stewardship prioritizes integrity over quick gain.'
      },
      {
        id: 2,
        prompt: 'You receive a surprise bonus. What is your first move?',
        options: ['Spend it all immediately', 'Plan giving, saving, and growth allocations'],
        correct: 1,
        feedback: 'A plan protects provision and multiplies impact.'
      },
      {
        id: 3,
        prompt: 'Your household budget is tight this month. What’s the best next step?',
        options: ['Ignore it and hope it improves', 'Review priorities and adjust spending'],
        correct: 1,
        feedback: 'Clarity and structure reduce financial stress.'
      },
      {
        id: 4,
        prompt: 'A business opportunity appears, but your systems are weak. What do you do?',
        options: ['Jump in without preparation', 'Strengthen systems before scaling'],
        correct: 1,
        feedback: 'Prepared systems help you sustain growth.'
      },
      {
        id: 5,
        prompt: 'Your team needs direction. What is the most responsible leadership move?',
        options: ['Stay vague to avoid conflict', 'Set a clear vision and roles'],
        correct: 1,
        feedback: 'Alignment unlocks progress and reduces friction.'
      }
    ]
  },
  budgetBuilder: {
    categories: [
      { name: 'Tithes & Generosity', percentage: 10, color: '#D4AF37' },
      { name: 'Savings & Investments', percentage: 20, color: '#10B981' },
      { name: 'Household Needs', percentage: 35, color: '#3B82F6' },
      { name: 'Business & Skills', percentage: 15, color: '#8B5CF6' },
      { name: 'Emergency Reserve', percentage: 10, color: '#F59E0B' },
      { name: 'Legacy & Giving', percentage: 10, color: '#EC4899' }
    ]
  }
};

// Mock Gamification Stats
export const gamificationStats = {
  points: 1250,
  badges: [
    { id: 1, name: 'Attendance Streak', icon: 'Fire', earned: true, date: '2026-01-05' },
    { id: 2, name: 'Assignment On-Time', icon: 'Check', earned: true, date: '2026-01-03' },
    { id: 3, name: 'Study Streak', icon: 'Book', earned: true, date: '2026-01-06' },
    { id: 4, name: 'Community Contributor', icon: 'Users', earned: false },
    { id: 5, name: 'Quiz Master', icon: 'Brain', earned: false },
    { id: 6, name: 'Financial Warrior', icon: 'Shield', earned: false }
  ],
  streaks: {
    attendance: 12,
    study: 8,
    assignments: 5
  },
  leaderboard: [
    { rank: 1, name: 'Sarah M.', points: 1850, badges: 8 },
    { rank: 2, name: 'John S.', points: 1250, badges: 6 },
    { rank: 3, name: 'David K.', points: 1100, badges: 5 },
    { rank: 4, name: 'Ruth W.', points: 980, badges: 5 },
    { rank: 5, name: 'Peter N.', points: 875, badges: 4 }
  ]
};

// Mock Contact Info
export const contactInfo = {
  phone: '+27 61 587 1145',
  email: 'info@schoolofshem.com',
  website: 'www.drtich.co.za',
  address: '2 Selbourne Rd, Fourways, Block 808 Hammets Crossing Office Park, Johannesburg'
};

// Mock Fee Structure
export const feeStructure = {
  onceOff: {
    price: 15950,
    discountedPrice: 14175,
    discount: 10,
    description: 'Pay full year fees in one instalment'
  },
  monthly: {
    price: 1450,
    description: 'Month-on-month payment plan'
  },
  groups: {
    minSize: 5,
    maxSize: 10,
    discount: 'Double discount benefits',
    description: 'Groups of five to ten members receive amazing discounts'
  }
};

// Mock Toast Messages
export const toastMessages = {
  success: 'Operation completed successfully!',
  error: 'An error occurred. Please try again.',
  warning: 'Please review your input.',
  info: 'New notification available.'
};
